import { render } from "./AuthLayout.vue?vue&type=template&id=53565c24&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=53565c24&lang=css"
import "./AuthLayout.vue?vue&type=style&index=1&id=53565c24&scoped=true&lang=css"

import exportComponent from "/var/www/kutchinaasp-uat.kutchina.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53565c24"]])

export default __exports__